import { render, staticRenderFns } from "./printTeam.vue?vue&type=template&id=618db8f0&scoped=true&"
import script from "./printTeam.vue?vue&type=script&lang=js&"
export * from "./printTeam.vue?vue&type=script&lang=js&"
import style0 from "./printTeam.vue?vue&type=style&index=0&id=618db8f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618db8f0",
  null
  
)

export default component.exports